var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadRequestedDocumentsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8F27C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.6667V19.8889C21 20.1836 20.8829 20.4662 20.6746 20.6746C20.4662 20.8829 20.1836 21 19.8889 21H12.1111C11.8164 21 11.5338 20.8829 11.3254 20.6746C11.1171 20.4662 11 20.1836 11 19.8889V17.6667M18.7778 14.8889L16 17.6667L13.2222 14.8889M16 17.6667V11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadRequestedDocumentsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-requested-documents-icon.cf39cdfcf75bb8e1540609354c9c3501.svg";